import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useSignupStyle = makeStyles((theme) => ({
  wrapper: {
    padding: '64px 0px 0px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiFormLabel-root': {
      ...theme.typography.body1,
      fontWeight: 700,
      color: colorSet.gray900
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colorSet.gray400
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: colorSet.gray400
    },
    '& input': {
      padding: '12px 12px 10px'
    },
    '& input::placeholder': {
      color: colorSet.gray500
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0
    }
  },
  container: {
    maxWidth: 600,
    width: 'calc(100vw - 32px)',
    display: 'flex',
    flexDirection: 'column'
  },
  updateFormTitle: {
    marginTop: 50,
    padding: '32px 0px'
  },
  accountFormTitle: {
    marginBottom: 32,
    [theme.breakpoints.down('xs')]: {
      marginTop: 22
    }
  },
  updateFormBox: {
    '& > div:last-child': {
      gap: '32px'
    },
    '& .MuiTypography-subtitle2': {
      fontSize: '14px'
    }
  }
}));
